import React from "react";
import "../Styles/Eligibilty.css";
import { Helmet } from "react-helmet-async";
import "bootstrap/dist/css/bootstrap.min.css";

const Eligibility = () => {
  return (
    <>
          <Helmet>
            <title>Eligibility Criteria|| ECO4 & GBIS</title>
            <meta
              name="description"
              content="Madani Marriage is dedicated to providing a trusted Madani Marriage platform..."
            />
          </Helmet>
    <section className="py-5 eligibility-section">
      <div className="container">
        {/* Page Title */}
        <h2 className="text-center mb-5 mt-5">Who Qualifies</h2>

        {/* Intro */}
        <p className="text-muted text-center mb-5">
          The ECO scheme is targeted towards <strong>low-income households</strong> 
          or those with <strong>vulnerable residents</strong>. Applicants must either 
          be homeowners OR have their landlord’s approval.
        </p>

        {/* ECO Eligibility */}
        <div className="mb-5">
          <h3 className="mb-4 text-primary">ECO Eligibility Criteria</h3>
          <div className="row g-4">
            <div className="col-md-4">
              <div className="p-4 bg-light rounded shadow-sm h-100">
                <h5 className="fw-bold mb-3">1. Benefits Criteria</h5>
                <ul className="list-unstyled mb-0">
                  <li>✅ Working tax or child tax credits</li>
                  <li>✅ Housing benefit</li>
                  <li>✅ Universal credit</li>
                  <li>✅ Pension credit</li>
                  <li>✅ Job seekers allowance (income related)</li>
                  <li>✅ Employment & support allowance</li>
                </ul>
              </div>
            </div>
            <div className="col-md-4">
              <div className="p-4 bg-light rounded shadow-sm h-100">
                <h5 className="fw-bold mb-3">2. Income Threshold</h5>
                <p>
                  If your total household income is{" "}
                  <strong>£31,000 or less</strong>, you may qualify for support 
                  under the Local Authority Flexible Eligibility route.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="p-4 bg-light rounded shadow-sm h-100">
                <h5 className="fw-bold mb-3">3. Health Conditions</h5>
                <p>
                  If someone in your household has a condition making them 
                  vulnerable to cold, you may qualify.
                </p>
                <ul className="list-unstyled mb-0">
                  <li>✅ Cardiovascular diseases</li>
                  <li>✅ Respiratory diseases</li>
                  <li>✅ Mobility issues</li>
                  <li>✅ Autoimmune disorders</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* GBIS Eligibility */}
        <div className="mb-5">
          <h3 className="mb-4 text-success">GBIS Eligibility Criteria</h3>
          <p>
            You can qualify for a GBIS grant if your house falls within{" "}
            <strong>Council Tax bands A–E (Wales)</strong> or{" "}
            <strong>A–D (England)</strong>. Unlike ECO, only your property needs 
            to qualify — meaning you don’t have to meet the same household benefit criteria.
          </p>
        </div>

        {/* EPC Section */}
        <div className="row align-items-center mb-5">
          <div className="col-md-6">
            <h3 className="text-warning mb-3">Check If Your Property Qualifies</h3>
            <p>
              If your home’s EPC is rated <strong>C or above</strong>, your home is 
              already considered energy efficient and may not qualify.
            </p>
            <p>
              If rated <strong>D or below</strong>, you likely qualify for grants 
              to upgrade your efficiency and lower your bills.
            </p>
            <ul className="list-unstyled">
              <li>✅ Multiple insulation options</li>
              <li>✅ Heating system upgrades</li>
              <li>✅ Air source heat pumps</li>
              <li>✅ Solar panels</li>
            </ul>
          </div>

        </div>

          <div className="col-md-12 text-center">
            {/* Replace this placeholder with EPC image */}
            <img
              src="https://www.stellarenergy.org/wp-content/themes/yootheme/cache/09/epctext-final-scaled-09bda138.avif"
              alt="EPC Rating"
              className="img-fluid rounded"
            />
          </div>

        {/* Contact Section */}
        <div className="text-center bg-light p-4 rounded shadow-sm mt-5">
          <h5 className="fw-bold">Get in touch</h5>
          <p>
            The best way to check if you qualify is to call us and be connected 
            to one of our specialists for a thorough eligibility check.
          </p>
          <a href="tel:+923068629918" className="btn btn-success">
            Call Now: (+92) 306 8629918
          </a>
        </div>
      </div>
    </section>
    </>
  );
};

export default Eligibility;
